<template>
    <c-list-card
        :height      = "80"
        :edit        = "false"
        :title-spacer = "false"
        border-width = "pa-2"
        @selected    = "onClick"
    >
        <template v-slot:title>
            <div class="v-flex w-100">
                <div class="card-title title-line">
                    {{ title }}
                </div>
                <v-spacer />
                <div class="text-right" style="width: 150px">
                    {{ mail.customer ? mail.customer.name : '---' }}
                </div>
                <div class="ml-1 mr-n1" style="width: 25px">
                    <v-icon v-if="mail.confirmed" size="22" color="success">mdi-check-circle</v-icon>
                    <v-icon v-if="!mail.confirmed" size="22" color="error">mdi-checkbox-blank-circle-outline</v-icon>
                </div>
            </div>
        </template>
        <template v-slot:body>
            <div class="card-subtitle v-flex">
                <div class="subject-line">
                    {{ mail.subject }}
                </div>
            </div>
        </template>
    </c-list-card>
 </template>

<script>

import Core      from "@/modules/core/service/Core";
import CListCard from "@/modules/core/components/utils/CListCard.vue";

export default {
    name: "PIncBouncedMailCard",

    components: {
        CListCard,
    },

    props: {
        mail: {

        }

    },

    computed: {
        delay () {
            return Core.format.delayInDays(this.item.begin);
        },

        future () {
            return Core.format.future(this.item.begin)
        },

        title () {
            return (this.mail.incidentId ? this.mail.incidentId : '---') + ' ' + this.mail.typeName + ' ' + this. dateAsString(this.mail.received);
        }
    },

    methods: {
        onClick () {
            this.$emit("mail", {
                title: this.title,
                mail : this.mail
            });
        },

        dateAsString (value) {
            return Core.format.datetime.display(value)
        },

        textColor () {
            const delay = Core.format.delayInMonth(this.item.begin);
            if (delay >= 3 || !this.item.begin) {
                return "error--text"
            }

            return 'black--text';
        }
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
}

.subject-line {
    max-height: 40px;
    overflow-y: scroll;
}

.title-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>